(function() {
  var style = document.createElement('style');
  style.textContent = [
    '#Details-HeaderMenu-2 { position: static; }',
    '#Details-HeaderMenu-2 > .header__submenu {',
    '  position: absolute; left: 0; right: 0; width: 100%;',
    '  display: none; flex-direction: row; justify-content: center;',
    '  gap: 64px; padding: 40px 80px;',
    '  background: #fff;',
    '  border-top: 1px solid rgba(0,0,0,0.06);',
    '  box-shadow: 0 12px 32px rgba(0,0,0,0.1); z-index: 100;',
    '}',
    '#Details-HeaderMenu-2[open] > .header__submenu { display: flex !important; }',
    '#Details-HeaderMenu-2 > .header__submenu > li {',
    '  flex: 0 1 260px; list-style: none;',
    '}',
    '',
    '/* Column headings */',
    '#Details-HeaderMenu-2 .header__submenu details > summary {',
    '  font-weight: 700 !important; font-size: 13px !important; letter-spacing: 0.12em !important;',
    '  text-transform: uppercase !important; margin-bottom: 14px !important; padding: 0 0 8px 0 !important;',
    '  border-bottom: 2px solid #e53e3e !important;',
    '  list-style: none !important; cursor: default !important;',
    '  color: rgb(var(--color-foreground)) !important;',
    '  pointer-events: none !important;',
    '}',
    '#Details-HeaderMenu-2 .header__submenu details > summary::marker,',
    '#Details-HeaderMenu-2 .header__submenu details > summary::-webkit-details-marker { display: none !important; }',
    '#Details-HeaderMenu-2 .header__submenu details > summary .icon-caret { display: none !important; }',
    '',
    '/* Sub-items list */',
    '#Details-HeaderMenu-2 .header__submenu details > ul {',
    '  display: flex !important; flex-direction: column !important; gap: 2px !important;',
    '  padding: 0 !important; margin: 0 !important; position: static !important;',
    '  box-shadow: none !important; background: transparent !important;',
    '  border: none !important; opacity: 1 !important; visibility: visible !important;',
    '}',
    '#Details-HeaderMenu-2 .header__submenu details > ul > li { list-style: none !important; }',
    '',
    '/* Links */',
    '#Details-HeaderMenu-2 .header__submenu details > ul a,',
    '#Details-HeaderMenu-2 .header__submenu details > ul a.header__menu-item,',
    '#Details-HeaderMenu-2 .header__submenu details > ul a.list-menu__item,',
    '#Details-HeaderMenu-2 .header__submenu details > ul a.link {',
    '  font-size: 15px !important; line-height: 1.4 !important; color: rgba(0,0,0,0.6) !important;',
    '  text-decoration: none !important; padding: 5px 0 !important; display: block !important;',
    '  pointer-events: auto !important; cursor: pointer !important;',
    '  transition: color 0.15s ease, padding-left 0.15s ease !important;',
    '}',
    '#Details-HeaderMenu-2 .header__submenu details > ul a:hover,',
    '#Details-HeaderMenu-2 .header__submenu details > ul a.header__menu-item:hover,',
    '#Details-HeaderMenu-2 .header__submenu details > ul a.list-menu__item:hover {',
    '  color: #e53e3e !important; padding-left: 4px !important;',
    '}',
    '',
    '/* Mobile */',
    '@media (max-width: 989px) {',
    '  #Details-HeaderMenu-2 > .header__submenu {',
    '    position: static !important; flex-direction: column !important; gap: 24px !important;',
    '    padding: 24px !important; box-shadow: none !important;',
    '  }',
    '  #Details-HeaderMenu-2 > .header__submenu > li { max-width: 100% !important; flex: auto !important; }',
    '}',
  ].join('\n');
  document.head.appendChild(style);

  function initMegaMenu() {
    var megaDetails = document.getElementById('Details-HeaderMenu-2');
    if (!megaDetails) return;
    var headerMenuEl = megaDetails.closest('header-menu');
    if (headerMenuEl && headerMenuEl.onToggle) headerMenuEl.onToggle = function() {};
    var subDetails = megaDetails.querySelectorAll('.header__submenu details');
    subDetails.forEach(function(d) { d.open = true; });
    if (window.matchMedia('(min-width: 990px)').matches) {
      var hoverTimeout;
      megaDetails.addEventListener('mouseenter', function() { clearTimeout(hoverTimeout); megaDetails.open = true; subDetails.forEach(function(d) { d.open = true; }); });
      megaDetails.addEventListener('mouseleave', function() { hoverTimeout = setTimeout(function() { megaDetails.open = false; }, 300); });
    }
    var summary = megaDetails.querySelector(':scope > summary');
    if (summary) summary.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); if (megaDetails.open) megaDetails.removeAttribute('open'); else { megaDetails.setAttribute('open', ''); subDetails.forEach(function(d) { d.open = true; }); } }, true);
    document.addEventListener('click', function(e) { if (megaDetails.open && !megaDetails.contains(e.target)) megaDetails.removeAttribute('open'); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && megaDetails.open) { megaDetails.removeAttribute('open'); if (summary) summary.focus(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMegaMenu); else initMegaMenu();
})();
